module.exports = __webpack_public_path__ + "cac342dc270228e17427b632d0290bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/raisa-cuevas.jpg
// module id = 523
// module chunks = 0